import React, { useEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";
import Button2 from "../../Components/Home/Button2";
import LoginPageCard from "../../Components/Login/LoginPageCard";
import lion_img from "../../Utils/images/Sell/login/lion.webp";
import peacock_img from "../../Utils/images/Sell/login/peacock.webp";
import { useSelector } from "react-redux";
import { getShopUserData, getUser } from "../../API/fetchExpressAPI";
import UserBadge from "../../UserBadge";

function Login() {
  const token = useSelector((state) => state.auth.userAccessToken);

  const [accessToken, setAccessToken] = useState("");
  const [isValidShop, setIsValidShop] = useState(false);

  // Fetch shop token and details
  const fetchShopToken = useCallback(async () => {
    try {
      const resp = await getUser(token);
      if (resp.length > 0) {
        const shopToken = resp?.find((u) => u?.shop_no !== null)?.shop_access_token;
        const getShopDetails = await getShopUserData(shopToken);

        if (
          getShopDetails.length > 0 &&
          getShopDetails[0].business_name.length > 0
        ) {
          setAccessToken(shopToken);
          setIsValidShop(true);
        } else {
          setAccessToken('');
          setIsValidShop(false);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      fetchShopToken();
    }
  }, [token, fetchShopToken]);

  // Define the logic for redirectTo dynamically for "Sell" based on shop validity
  const sellRedirectTo = accessToken
    ? isValidShop
      ? `../../sell/support/shop/shop-detail/${accessToken}`
      : "../../sell/eshop"
    : "../../sell/login";

  return (
    <Box className="login_wrapper">
      <Box className="container">
        <Box className="col">
          {/* <Button2 text="Back" redirectTo={-1} /> */}
          <UserBadge
                    handleBadgeBgClick="../"
                    handleLogin="../login"
                    handleLogoutClick="../../"
                    />
        </Box>

        {/* Always Render LoginPageCard but Change Redirect Dynamically */}
        <Box className="col">
          <LoginPageCard
            title="Sell"
            imgSrc={peacock_img}
            redirectTo={sellRedirectTo}
          />
        </Box>

        <Box className="col">
          <LoginPageCard
            title="Buy"
            imgSrc={lion_img}
            redirectTo="../../sell/esale"
          />
        </Box>
      </Box>
    </Box>
  );
}

export default Login;
